window.addEventListener('SITE_START', () => {
  // 이메일
  const $emailGroups = document.querySelectorAll('.email-domain-group');
  if (!$emailGroups.length) return;

  $emailGroups.forEach($emailGroup => {
    const $dropdown = $emailGroup.querySelector('.email-domain');
    const $value = $dropdown.querySelector('.dropdown__value');
    const $options = $dropdown.querySelectorAll('.dropdown__option');
    const $input = $emailGroup.querySelector('.email-direct');

    if (!$dropdown || !$value || !$input) return;

    // 드롭다운에서 옵션 클릭 시 input 처리
    $options.forEach($option => {
      $option.addEventListener('click', (e) => {
        const val = $option.getAttribute('data-value');
        const text = $option.textContent.trim();

        // 직접입력 선택 → input 초기화 & 활성화
        if (val === 'custom') {
          $input.value = '';
          $input.removeAttribute('readonly');
          $input.focus();
        } else {
          // 도메인 선택 → 값 채우고 readonly 처리
          $input.value = text;
          $input.setAttribute('readonly', 'readonly');
        }
      });
    });
  });
});
